(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockKundenportalInfo', {
            bindings: {
                pksRegisterData: '<abkiPksRegisterData',
                angebotVm: '<abkiAngebotVm'
            },
            templateUrl: 'bloecke/kundenportal/blockKundenportalInfo.html',
            controller: BlockKundenportalInfoController,
            controllerAs: 'kundenportalInfoVm'
        });

    BlockKundenportalInfoController.$inject = [
        'lodash',
        'AppConfig'
    ];
    function BlockKundenportalInfoController(_, AppConfig) {
        var vm = this;

        vm.$onInit = onInit;

        vm.isErlaubt = isErlaubt;

        function activate() {
            vm.linkKundenportal = AppConfig.APP.urls.kundenportalInfo;
        }

        function onInit() {
            activate();
        }

        function isErlaubt() {
            return (
                _.get(AppConfig.REITER, 'abschluss.blockKundenportal') !== false &&
                !vm.angebotVm.isTokenLoginSession &&
                _.get(vm.pksRegisterData, 'isVisible') !== true
            );
        }
    }
})();
